<template>
  <v-layout
    row
    fill-height
    align-center
    justify-center
    wrap
    style="background-color: var(--primary-normal)"
  >
    <v-flex shrink>
      <div class="warning-message">
        404
      </div>
      <div class="warning-message" style="font-size: 30px;">
        Sorry, the page you're looking for doesn't exist.
      </div>

      <v-btn
        @click="$router.back()"
        text
        color="accent"
        style="text-transform: none"
      >
        Previous Page
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style scoped>
.warning-message {
  color: white;
  font-size: 50px;
  font-weight: 900;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue